module.exports = __webpack_public_path__ + "img/b0d15ca0835f1c250ba93b41e240951.8032975a.jpg";